<template>
  <div class="article-row" :style="rowStyles">
    <div class="article-row__container">
      <slot />
    </div>
    <slot name="background" />
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * Row styles
     */
    rowStyles() {
      const styles = {}
      if (this.backgroundColor) {
        styles['background-color'] = this.backgroundColor
      }
      if (this.desktopHeight) {
        styles['--row-height-desktop'] = this.desktopHeight
      }
      if (this.mobileHeight) {
        styles['--row-height-mobile'] = this.mobileHeight
      }
      if (this.textColor) {
        styles.color = this.textColor
      }

      return styles
    },
  },
  props: {
    /**
     * Row background color
     */
    backgroundColor: {
      default: '',
      type: String,
    },

    /**
     * Desktop row height,
     * in px,
     * default: auto
     */
    desktopHeight: {
      default: '',
      type: String,
    },

    /**
     * Mobile row height,
     * in px,
     * default: auto
     */
    mobileHeight: {
      default: '',
      type: String,
    },

    /**
     * Row text color
     */
    textColor: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-row {
  @apply flex justify-center items-center;
  @apply relative w-screen;
  margin-left: calc(50% - 50vw);
}
.article-row__container {
  @apply w-full z-1;
}

@screen mobile {
  .article-row {
    height: var(--row-height-mobile, auto);
  }
}

@screen desktop {
  .article-row {
    height: var(--row-height-desktop, auto);
  }
}
</style>
